export const categories = [
  { id: 'game', name: '游戏直播', icon: 'ri-gamepad-line', slug: 'game', count: 1280 },
  { id: 'entertainment', name: '娱乐直播', icon: 'ri-music-2-line', slug: 'entertainment', count: 960 },
  { id: 'lifestyle', name: '生活直播', icon: 'ri-home-heart-line', slug: 'lifestyle', count: 740 },
  { id: 'sports', name: '体育直播', icon: 'ri-basketball-line', slug: 'sports', count: 520 },
  { id: 'esports', name: '电竞赛事', icon: 'ri-trophy-line', slug: 'esports', count: 380 },
  { id: 'food', name: '美食直播', icon: 'ri-restaurant-line', slug: 'food', count: 450 },
  { id: 'travel', name: '户外旅行', icon: 'ri-compass-3-line', slug: 'travel', count: 320 },
  { id: 'music', name: '音乐才艺', icon: 'ri-mic-line', slug: 'music', count: 610 },
];

export const streams = [
  {
    id: 's1',
    title: '王者荣耀巅峰赛冲分！今晚冲击国服第一',
    anchor: '电竞小王子',
    anchorAvatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20male%20streamer%20avatar%20with%20stylish%20haircut%20and%20gaming%20headset%2C%20modern%20portrait%20style%20on%20clean%20light%20background%2C%20warm%20tone%2C%20professional%20streamer%20look&width=120&height=120&seq=avatar-s1&orientation=squarish',
    viewers: 28500,
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20mobile%20game%20Honor%20of%20Kings%20gameplay%20screenshot%20with%20vibrant%20colors%20and%20epic%20team%20fight%20scene%2C%20gaming%20stream%20overlay%20style%2C%20professional%20esports%20aesthetic&width=640&height=360&seq=stream-s1&orientation=landscape',
    category: 'game',
    isLive: true,
    tags: ['王者荣耀', 'MOBA', '巅峰赛']
  },
  {
    id: 's2',
    title: '深夜治愈聊天室，一起听歌聊心事',
    anchor: '温暖小酒馆',
    anchorAvatar: 'https://readdy.ai/api/search-image?query=Gentle%20Chinese%20female%20streamer%20portrait%20with%20warm%20smile%20and%20cozy%20sweater%2C%20soft%20lighting%20on%20clean%20background%2C%20friendly%20approachable%20look&width=120&height=120&seq=avatar-s2&orientation=squarish',
    viewers: 15600,
    thumbnail: 'https://readdy.ai/api/search-image?query=Cozy%20room%20at%20night%20with%20warm%20string%20lights%20and%20music%20setup%2C%20relaxing%20atmosphere%20with%20headphones%20and%20microphone%2C%20soft%20warm%20tones%2C%20lifestyle%20stream%20vibe&width=640&height=360&seq=stream-s2&orientation=landscape',
    category: 'entertainment',
    isLive: true,
    tags: ['聊天', '音乐', '治愈']
  },
  {
    id: 's3',
    title: 'LOL韩服高端局，职业选手在线教学',
    anchor: '峡谷教官',
    anchorAvatar: 'https://readdy.ai/api/search-image?query=Serious%20Chinese%20male%20gamer%20avatar%20with%20gaming%20headphones%20and%20intense%20focus%2C%20professional%20esports%20style%20on%20dark%20background%2C%20sharp%20portrait&width=120&height=120&seq=avatar-s3&orientation=squarish',
    viewers: 42300,
    thumbnail: 'https://readdy.ai/api/search-image?query=League%20of%20Legends%20high%20rank%20gameplay%20with%20epic%20teamfight%20and%20colorful%20ability%20effects%2C%20Korean%20server%20match%2C%20professional%20streaming%20layout&width=640&height=360&seq=stream-s3&orientation=landscape',
    category: 'game',
    isLive: true,
    tags: ['LOL', 'MOBA', '教学']
  },
  {
    id: 's4',
    title: '周末户外探险，带你徒步最美山脊线',
    anchor: '山河远行',
    anchorAvatar: 'https://readdy.ai/api/search-image?query=Outdoor%20enthusiast%20Chinese%20male%20with%20hiking%20gear%20and%20warm%20smile%2C%20adventure%20portrait%20on%20clean%20light%20background%2C%20friendly%20natural%20look&width=120&height=120&seq=avatar-s4&orientation=squarish',
    viewers: 8900,
    thumbnail: 'https://readdy.ai/api/search-image?query=Beautiful%20mountain%20ridge%20hiking%20trail%20with%20dramatic%20clouds%20and%20golden%20sunset%20light%2C%20aerial%20landscape%20view%2C%20inspiring%20outdoor%20adventure%20scene&width=640&height=360&seq=stream-s4&orientation=landscape',
    category: 'travel',
    isLive: true,
    tags: ['户外', '徒步', '旅行']
  },
  {
    id: 's5',
    title: 'CS2职业联赛直播，亚洲区决赛',
    anchor: '赛事直播间',
    anchorAvatar: 'https://readdy.ai/api/search-image?query=Esports%20tournament%20caster%20avatar%20with%20professional%20headset%20and%20energetic%20expression%2C%20studio%20portrait%20on%20clean%20background&width=120&height=120&seq=avatar-s5&orientation=squarish',
    viewers: 67800,
    thumbnail: 'https://readdy.ai/api/search-image?query=Counter%20Strike%202%20professional%20esports%20match%20in%20large%20arena%20with%20dramatic%20stage%20lighting%20and%20excited%20crowd%2C%20competitive%20gaming%20atmosphere&width=640&height=360&seq=stream-s5&orientation=landscape',
    category: 'esports',
    isLive: true,
    tags: ['CS2', '电竞', '联赛']
  },
  {
    id: 's6',
    title: '米其林大厨教你做正宗川菜',
    anchor: '厨房老李',
    anchorAvatar: 'https://readdy.ai/api/search-image?query=Friendly%20Chinese%20chef%20portrait%20with%20white%20apron%20and%20warm%20smile%2C%20professional%20kitchen%20background%2C%20approachable%20cooking%20expert&width=120&height=120&seq=avatar-s6&orientation=squarish',
    viewers: 12300,
    thumbnail: 'https://readdy.ai/api/search-image?query=Professional%20chef%20cooking%20authentic%20Sichuan%20cuisine%20in%20well%20equipped%20kitchen%20with%20steaming%20wok%20and%20colorful%20fresh%20ingredients%2C%20food%20photography%20style&width=640&height=360&seq=stream-s6&orientation=landscape',
    category: 'food',
    isLive: true,
    tags: ['美食', '川菜', '教学']
  },
  {
    id: 's7',
    title: '吉他弹唱会，点歌互动中',
    anchor: '弦动心声',
    anchorAvatar: 'https://readdy.ai/api/search-image?query=Artistic%20Chinese%20female%20musician%20portrait%20with%20acoustic%20guitar%2C%20creative%20bohemian%20style%20on%20clean%20light%20background%2C%20soulful%20expression&width=120&height=120&seq=avatar-s7&orientation=squarish',
    viewers: 9800,
    thumbnail: 'https://readdy.ai/api/search-image?query=Acoustic%20guitar%20performance%20in%20cozy%20room%20with%20warm%20fairy%20lights%20and%20musical%20atmosphere%2C%20intimate%20concert%20vibe%2C%20soft%20romantic%20lighting&width=640&height=360&seq=stream-s7&orientation=landscape',
    category: 'music',
    isLive: true,
    tags: ['音乐', '吉他', '弹唱']
  },
  {
    id: 's8',
    title: 'NBA季后赛实时解说，精彩不容错过',
    anchor: '球事早知道',
    anchorAvatar: 'https://readdy.ai/api/search-image?query=Sports%20commentator%20Chinese%20male%20with%20energetic%20expression%20and%20professional%20headset%2C%20dynamic%20portrait%20on%20clean%20background&width=120&height=120&seq=avatar-s8&orientation=squarish',
    viewers: 34500,
    thumbnail: 'https://readdy.ai/api/search-image?query=NBA%20basketball%20playoff%20game%20with%20intense%20dunk%20action%20and%20dramatic%20arena%20lighting%2C%20professional%20sports%20photography%2C%20exciting%20atmosphere&width=640&height=360&seq=stream-s8&orientation=landscape',
    category: 'sports',
    isLive: true,
    tags: ['NBA', '篮球', '季后赛']
  },
];

export const anchors = [
  {
    id: 'a1',
    name: '电竞小王子',
    avatar: 'https://readdy.ai/api/search-image?query=Charismatic%20young%20Chinese%20male%20gaming%20streamer%20portrait%20with%20stylish%20hair%20and%20trendy%20hoodie%2C%20professional%20studio%20lighting%20on%20clean%20background%2C%20popular%20influencer%20look&width=200&height=200&seq=anchor-a1&orientation=squarish',
    followers: '128万',
    category: '游戏',
    description: '王者荣耀国服第一，幽默风趣的直播风格',
    isLive: true,
  },
  {
    id: 'a2',
    name: '温暖小酒馆',
    avatar: 'https://readdy.ai/api/search-image?query=Beautiful%20Chinese%20female%20streamer%20with%20warm%20gentle%20smile%20and%20elegant%20casual%20outfit%2C%20soft%20portrait%20lighting%20on%20clean%20background%2C%20soothing%20personality&width=200&height=200&seq=anchor-a2&orientation=squarish',
    followers: '96万',
    category: '娱乐',
    description: '治愈系聊天主播，温暖陪伴每一个夜晚',
    isLive: true,
  },
  {
    id: 'a3',
    name: '峡谷教官',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20male%20esports%20coach%20portrait%20with%20sharp%20focus%20and%20team%20jersey%2C%20clean%20studio%20background%2C%20competitive%20gamer%20aesthetic&width=200&height=200&seq=anchor-a3&orientation=squarish',
    followers: '85万',
    category: '游戏',
    description: '前职业选手，硬核教学带你上分',
    isLive: true,
  },
  {
    id: 'a4',
    name: '厨房老李',
    avatar: 'https://readdy.ai/api/search-image?query=Middle-aged%20Chinese%20chef%20portrait%20with%20warm%20genuine%20smile%20and%20professional%20chef%20coat%2C%20clean%20studio%20lighting%2C%20experienced%20cooking%20master&width=200&height=200&seq=anchor-a4&orientation=squarish',
    followers: '62万',
    category: '美食',
    description: '三十年厨龄老厨师，教你地道家常菜',
    isLive: false,
  },
  {
    id: 'a5',
    name: '山河远行',
    avatar: 'https://readdy.ai/api/search-image?query=Adventurous%20Chinese%20male%20outdoor%20explorer%20portrait%20with%20hiking%20backpack%20and%20sunlit%20face%2C%20clean%20studio%20background%2C%20energetic%20travel%20enthusiast&width=200&height=200&seq=anchor-a5&orientation=squarish',
    followers: '48万',
    category: '户外',
    description: '走遍中国山川大河，带你云旅行',
    isLive: false,
  },
  {
    id: 'a6',
    name: '弦动心声',
    avatar: 'https://readdy.ai/api/search-image?query=Talented%20Chinese%20female%20singer%20songwriter%20portrait%20with%20acoustic%20guitar%20and%20artistic%20outfit%2C%20clean%20studio%20background%2C%20creative%20musician%20vibe&width=200&height=200&seq=anchor-a6&orientation=squarish',
    followers: '73万',
    category: '音乐',
    description: '原创音乐人，用歌声治愈你的心灵',
    isLive: false,
  },
  {
    id: 'a7',
    name: '球事早知道',
    avatar: 'https://readdy.ai/api/search-image?query=Energetic%20Chinese%20male%20sports%20commentator%20portrait%20with%20passionate%20expression%20and%20casual%20sportswear%2C%20clean%20studio%20background&width=200&height=200&seq=anchor-a7&orientation=squarish',
    followers: '55万',
    category: '体育',
    description: '专业球赛解说，让你看懂每一场比赛',
    isLive: false,
  },
  {
    id: 'a8',
    name: '甜心舞者',
    avatar: 'https://readdy.ai/api/search-image?query=Graceful%20Chinese%20female%20dancer%20portrait%20with%20elegant%20pose%20and%20fashionable%20outfit%2C%20clean%20studio%20background%2C%20professional%20performer%20look&width=200&height=200&seq=anchor-a8&orientation=squarish',
    followers: '110万',
    category: '娱乐',
    description: '舞蹈达人，带你感受节奏的魅力',
    isLive: true,
  },
];

export const articles = [
  {
    id: 'art1',
    title: '2026年最值得关注的十大游戏主播，你关注了几个？',
    excerpt: '随着直播行业的蓬勃发展，游戏直播已成为最受欢迎的内容类型之一。我们为你盘点了今年最值得关注的十位游戏主播，他们各具特色...',
    cover: 'https://readdy.ai/api/search-image?query=Top%20Chinese%20gaming%20streamers%20collage%20with%20colorful%20gaming%20setup%20and%20RGB%20lighting%2C%20modern%20esports%20aesthetic%20with%20multiple%20screens%2C%20editorial%20style&width=800&height=450&seq=article-art1&orientation=landscape',
    category: '行业资讯',
    date: '2026-08-08',
    readTime: '8分钟',
    content: '随着直播行业的蓬勃发展，游戏直播已成为最受欢迎的内容类型之一。2026年，蘑菇tv平台上涌现出大批优秀游戏主播，他们凭借独特的个人魅力和精湛的游戏技术，吸引了数以百万计的粉丝关注。本文将为你盘点今年最值得关注的十大游戏主播，看看你关注了几个？'
  },
  {
    id: 'art2',
    title: '高清直播技术揭秘：蘑菇tv如何实现超低延迟',
    excerpt: '在直播体验中，画质和延迟是最关键的两个指标。蘑菇tv通过自研的流媒体传输技术，实现了1080P高清画质下低于1秒的超低延迟...',
    cover: 'https://readdy.ai/api/search-image?query=Modern%20streaming%20technology%20server%20room%20with%20glowing%20fiber%20optic%20cables%20and%20digital%20data%20flow%2C%20futuristic%20tech%20aesthetic%2C%20clean%20professional%20look&width=800&height=450&seq=article-art2&orientation=landscape',
    category: '技术前沿',
    date: '2026-08-05',
    readTime: '6分钟',
    content: '在直播体验中，画质和延迟是最关键的两个指标。蘑菇tv技术团队经过多年的研发和优化，成功打造了一套高效稳定的流媒体传输系统。通过自研的编码算法和智能CDN调度策略，我们在1080P高清画质下实现了低于1秒的超低延迟直播体验。'
  },
  {
    id: 'art3',
    title: '从零开始做主播：新手入门完全指南',
    excerpt: '想做主播却不知从何下手？本文从设备选择、内容定位、互动技巧等方面，为新手主播提供一份完整的入门指南，助你快速起航...',
    cover: 'https://readdy.ai/api/search-image?query=Beginner%20streaming%20setup%20with%20microphone%20webcam%20and%20ring%20light%20on%20clean%20desk%2C%20cozy%20home%20studio%20aesthetic%2C%20warm%20lighting%2C%20approachable%20beginner%20friendly&width=800&height=450&seq=article-art3&orientation=landscape',
    category: '主播指南',
    date: '2026-08-01',
    readTime: '12分钟',
    content: '想做主播却不知从何下手？别担心，这篇完全指南将带你从零开始，一步步了解主播行业的方方面面。从硬件设备的选择，到内容方向的定位，再到与观众互动的技巧，我们将为你详细解析每一个环节。'
  },
  {
    id: 'art4',
    title: '蘑菇tv社区公约更新：共建文明直播环境',
    excerpt: '为营造更加健康积极的直播社区氛围，蘑菇tv对社区公约进行了全面升级。新公约在内容审核、用户行为规范等方面做出重要调整...',
    cover: 'https://readdy.ai/api/search-image?query=Professional%20community%20guidelines%20document%20with%20friendly%20colorful%20icons%20and%20modern%20design%2C%20clean%20digital%20aesthetic%20on%20light%20background&width=800&height=450&seq=article-art4&orientation=landscape',
    category: '平台公告',
    date: '2026-07-28',
    readTime: '5分钟',
    content: '为营造更加健康积极的直播社区氛围，蘑菇tv对社区公约进行了全面升级。新公约在内容审核标准、用户行为规范、主播责任义务等方面做出了重要调整和完善。我们相信，一个文明有序的直播环境需要平台、主播和观众共同努力。'
  },
  {
    id: 'art5',
    title: '夏季电竞赛事日历：这些比赛不容错过',
    excerpt: '2026年夏季，国内外电竞赛事密集举办。从LPL夏季赛到CS2 Major，从王者荣耀世界冠军杯到DOTA2国际邀请赛...',
    cover: 'https://readdy.ai/api/search-image?query=Exciting%20esports%20tournament%20stage%20with%20massive%20LED%20screens%20and%20cheering%20crowd%20in%20large%20arena%2C%20dramatic%20lighting%20and%20confetti%2C%20grand%20competitive%20atmosphere&width=800&height=450&seq=article-art5&orientation=landscape',
    category: '电竞赛事',
    date: '2026-07-20',
    readTime: '10分钟',
    content: '2026年夏季，国内外电竞赛事密集举办。从LPL夏季赛到CS2 Major，从王者荣耀世界冠军杯到DOTA2国际邀请赛，精彩对决接连不断。蘑菇tv将全程高清直播这些顶级赛事，让你不错过任何一个精彩瞬间。'
  },
  {
    id: 'art6',
    title: '如何通过直播变现：主播收入模式全解析',
    excerpt: '直播不仅是分享生活的窗口，也是许多人的职业选择。本文详细解析了当前主流的直播变现模式，包括礼物打赏、品牌合作、电商带货等...',
    cover: 'https://readdy.ai/api/search-image?query=Creative%20monetization%20concept%20with%20floating%20coins%20and%20gifts%20around%20streaming%20microphone%2C%20warm%20golden%20lighting%2C%20modern%20financial%20success%20aesthetic&width=800&height=450&seq=article-art6&orientation=landscape',
    category: '主播指南',
    date: '2026-07-15',
    readTime: '9分钟',
    content: '直播不仅是分享生活的窗口，也是越来越多人的职业选择。随着直播行业的成熟，主播的变现渠道也日益多元化。从传统的礼物打赏到品牌商务合作，从电商直播带货到知识付费内容，本文将为你详细解析当前主流的直播变现模式。'
  },
];

export const faqData = [
  {
    question: '蘑菇tv需要付费吗？',
    answer: '蘑菇tv基础服务完全免费，您可以免费观看所有直播内容和短视频。我们同时提供会员服务，会员可享受去广告、高清画质、专属表情等增值权益。'
  },
  {
    question: '如何成为蘑菇tv的主播？',
    answer: '您可以通过蘑菇tv App或官网的"成为主播"入口提交申请。完成实名认证后，您将获得直播权限。我们为新主播提供完善的培训体系和流量扶持计划。'
  },
  {
    question: '蘑菇tv支持哪些设备观看？',
    answer: '蘑菇tv支持全平台观看，包括网页版、iOS App、Android App、iPad以及智能电视（TV版）。所有平台数据同步，让您随时随地畅享直播。'
  },
  {
    question: '直播回放可以看吗？',
    answer: '可以的！大部分主播的直播内容都会自动生成回放，您可以在主播主页或直播结束后查看录播视频。部分付费内容可能需要会员权限。'
  },
  {
    question: '如何联系客服解决问题？',
    answer: '您可以通过蘑菇tv App内的"我的-帮助与反馈"联系在线客服，或发送邮件至 support@mogu.tv。我们的客服团队7×24小时为您服务。'
  },
  {
    question: '蘑菇tv视频支持下载离线观看吗？',
    answer: '蘑菇tv会员用户可以将部分短视频和录播内容下载到本地，方便在没有网络的环境下观看。下载的视频在会员有效期内均可播放。'
  },
];

export const stats = [
  { label: '日活用户', value: '5000万+', icon: 'ri-user-line' },
  { label: '签约主播', value: '10万+', icon: 'ri-live-line' },
  { label: '日均直播时长', value: '80万小时+', icon: 'ri-time-line' },
  { label: '覆盖国家地区', value: '30+', icon: 'ri-global-line' },
];